import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Twitter, Github } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-muted/30 mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_50845b9f-14b0-452c-b665-fa440207483a/artifacts/opizci2q_hack.png" 
              alt="Hackov8" 
              className="h-12 w-auto"
            />
            <p className="text-muted-foreground text-sm leading-relaxed">
              The ultimate platform where developers, designers, and innovators collaborate to create groundbreaking solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-foreground font-heading font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* For Users */}
          <div>
            <h3 className="text-foreground font-heading font-semibold mb-4">For Users</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Browse Hackathons
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  My Profile
                </Link>
              </li>
              <li>
                <Link to="/settings" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Settings
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-foreground font-heading font-semibold mb-4">Connect</h3>
            <div className="space-y-3 mb-4">
              <a
                href="https://www.linkedin.com/company/getsocialnow/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group"
              >
                <div className="w-9 h-9 rounded-lg bg-secondary group-hover:bg-primary flex items-center justify-center transition-colors">
                  <Linkedin className="w-4 h-4 text-foreground group-hover:text-white" />
                </div>
                <span className="text-sm">LinkedIn</span>
              </a>
              <a
                href="mailto:hackov8@gmail.com"
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group"
              >
                <div className="w-9 h-9 rounded-lg bg-secondary group-hover:bg-primary flex items-center justify-center transition-colors">
                  <Mail className="w-4 h-4 text-foreground group-hover:text-white" />
                </div>
                <span className="text-sm">hackov8@gmail.com</span>
              </a>
            </div>
            <p className="text-muted-foreground text-xs">
              For collaboration requests, reach out to us!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {currentYear} Hackov8. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
